import React, { useEffect, useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, showToast } from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { getOrganizationLocaleInfo, getRole, updateOrganization, updateOrganizationLocaleInfo, updateRole, updateUser } from "../../../../../redux/slices/setting/settingApi";
import { setOrganizationLocale, setOrganizationLocaleType, setRoleLocale, setUserLocale } from "../../../../../redux/slices/auth/authSlice";
import { useLoginUser } from "../../../../../hooks/useLoginUser";

const countryMapping = {
  USA: { currency: "USD", timeZone: 2 }, // EST
  India: { currency: "INR", timeZone: 1 }, // IST
  UK: { currency: "GBP", timeZone: 3 }, // PST
  Australia: { currency: "AUD", timeZone: 3 },
};


const BENCH_USER_MODULE = 4; 
const LocalInformation = () => {
  const [settingType, setSettingType] = useState(1);
  const [module, setModule] = useState([]);
  const [role, setRole] = useState("");
  const [roleSelection, setRoleSelection] = useState("");
  const dispatch = useDispatch();
  const savedLocalInfo = useSelector(
    (state) => state.settings.companyProfile?.localInfo
  ); 


     const { userData: loginUserData } = useLoginUser();
      const moduleNumber = loginUserData?.role?.module;
      const isBenchUser = BENCH_USER_MODULE===moduleNumber;
  const { user } = useSelector((state) => state?.auth);
  const [loading, setLoading] = useState(false);

  const [country, setCountry] = useState("");
  const [currency, setCurrency] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [timeFormat, setTimeFormat] = useState("");

  const timeZoneMapping = {
    1: { currency: "INR" },
    2: { currency: "USD" },
    3: { currency: "GBP" },
  };

  const updateOrganizationLocaleType = async (localeType) => {
    try {
      const res = await updateOrganization({
        id: user?.data?.organizationId?._id,
        payload: {
          $set: {
            "locale.default": localeType,
          }
        }
      });
      if(res?.data) {
        dispatch(setOrganizationLocaleType(localeType));
      } else {
        showToast("Failed to update the org locale","error");
      }
    } catch (err) {
      console.error("Error updating organization locale type:", err);
    }
  };


  const handleSave = async () => {
    const payload = {
      // coOps: country,
      currency: currency,
      timezone: timeZone,
      timeFormat: timeFormat,
    };

    // if (settingType == 2 && role == 2) {
    //   let product = null;
    //   if (module.includes(1)) product = "ats";
    //   if (module.includes(2)) product = "workforce";
    //   if (!product) {
    //     showToast("Please select ATS or Workforce", "error");
    //     return;
    //   }
    //   try {
    //     const res = await updateUser({
    //       id: user?.data?._id,
    //       payload: {
    //         $set: {
    //           [`locale.${product}`]: payload,
    //         },
    //       },
    //     });
    //     if (res?.data) {
    //       showToast("Localinfo updated successfully!", "success");
    //     } else {
    //       showToast("Failed to update Localinfo", "error");
    //     }
    //   } catch (err) {
    //     console.error("Error updating user:", err);
    //   }
    //   return;
    // }
    if (settingType == 2 && role == 2) {
      if (module.length === 0) {
        showToast("Please select ATS or Workforce or Benchsales", "error");
        return;
      }

      let updateFields = {};

      if (module.includes(1)) {
        updateFields["locale.ats"] = payload;
      }

      if (module.includes(2)) {
        updateFields["locale.workforce"] = payload;
      }
      if (module.includes(3)) {
        updateFields["locale.benchsales"] = payload;
      }

      try {
        const res = await updateUser({
          id: user?.data?._id,
          payload: {
            $set: updateFields,
          },
        });

        if (res?.data) {
          showToast("Locale updated successfully!", "success");
          const reduxPayload = {};

          if (updateFields["locale.ats"]) {
            reduxPayload.ats = payload;
          }

          if (updateFields["locale.workforce"]) {
            reduxPayload.workforce = payload;
          }

          if (updateFields["locale.benchsales"]) {
            reduxPayload.benchsales = payload;
          }

          dispatch(setUserLocale(reduxPayload));
          await updateOrganizationLocaleType(3);   // Individual-Based
        } else {
          showToast("Failed to update Locale", "error");
        }
      } catch (err) {
        console.error("Error updating user:", err);
      }

      return;
    }


    if (settingType == 2 && role == 1 && roleSelection) {
      try {
        const res = await updateRole({
          coll: "Role",
          id: roleSelection?.id, 
          payload: {
            $set: {
              locale: payload,
            },
          },
        });
        if (res?.data) {
          showToast("Locale updated for role!", "success");
          await updateOrganizationLocaleType(2); // Role-Based
          const loggedInRoleType = user?.data?.role?.type; 
          const selectedRoleType = roleSelection?.type;   

          if (loggedInRoleType === selectedRoleType) {
            dispatch(setRoleLocale({ locale: payload }));
          }
        } else {
          showToast("Failed to update role locale", "error");
        }
      } catch (err) {
        console.error("Role update error:", err);
        showToast("Error updating role locale", "error");
      }
      return;
    }

    // dispatch(
    //   setLocalInfoStart({
    //     id: user?.data.organizationId._id,
    //     localeInfo: payload,
    //   })
    // );
    // if(settingType == 1) {
    //   dispatch(
    //     setLocalInfoStart({
    //       id: user?.data.organizationId._id,
    //       localeInfo: payload,
    //     })
    //   );
    //   await updateOrganizationLocaleType(1); // Global
    // }
    if (settingType == 1) {
      if(!currency || !timeFormat || !timeZone) {
        showToast("Please fill all the fields!");
        return;
      }
      try {
        const res = await updateOrganizationLocaleInfo({
          id: user?.data.organizationId._id,
          locale: payload,
        });

        if (res?.data) {
          showToast("LocalInfo updated successfully!", "success");

          dispatch(setOrganizationLocale(payload));

          await updateOrganizationLocaleType(1); // Global
        } else {
          showToast("Failed to update locale", "error");
        }
      } catch (err) {
        console.error("Error updating organization locale:", err);
        showToast("Error updating locale", "error");
      }

      return;
    }

  };

  const handleCountryChange = (value) => {
    setCountry(value);
    const mapping = countryMapping[value] || { currency: "", timeZone: "" };
    setCurrency(mapping.currency);
    setTimeZone(mapping.timeZone);
  };

  const handleTimeZoneChange = (value) => {
    setTimeZone(value);

    const mapping = timeZoneMapping[value];

    if (mapping) {
      setCountry(mapping.country || "");
      setCurrency(mapping.currency || "");
    }
  };


  // useEffect(() => {
  //   if (savedLocalInfo && settingType === 1) {
  //     setCountry(savedLocalInfo?.coOps || "");
  //     setCurrency(savedLocalInfo?.currency || "");
  //     setTimeZone(savedLocalInfo?.timezone || "");
  //     setTimeFormat(savedLocalInfo?.timeFormat || "");
  //   }
  // }, [savedLocalInfo]);

  // useEffect(() => {
  //   if (
  //     (!savedLocalInfo ||
  //     (!savedLocalInfo.coOps &&
  //       !savedLocalInfo.currency &&
  //       !savedLocalInfo.timezone)) && settingType === 1
  //   ) {
  //     dispatch(
  //       getLocalInfoStart({
  //         coll: "Organization",
  //         fil: {
  //           uiid: { type: "NONE", value: user?.data.organizationId.uiid },
  //         },
  //         ret: "localeInfo",
  //       })
  //     );
  //   }
  // }, [dispatch, user, savedLocalInfo]);

  useEffect(() => {
    const fetchRoleLocale = async () => {
      if (!roleSelection || role != 1) return;

      try {
        const res = await getRole({ 
          coll: "Role",
          // uiid: roleSelection?.value, 
          fil : JSON.stringify({
            uiid: { type: "NONE", value: roleSelection?.value }
          }),
          ret: "uiid locale" 
        });

        const locale = res?.data?.data?.locale;

        if (locale) {
          setCurrency(locale?.currency || "");
          setTimeZone(locale.timezone || "");
          if ([1, 2].includes(locale.timeFormat)) {
            setTimeFormat(locale.timeFormat);
          } else {
            setTimeFormat("");
          }
        } else {
          setCurrency("");
          setTimeZone("");
          setTimeFormat("");
        }
      } catch (err) {
        console.error("Error fetching role locale:", err);
      }
    };

    fetchRoleLocale();
  }, [roleSelection, role]);

  useEffect(() => {
    if (settingType == 2 && role == 2) {

      const individualLocale = user?.data?.locale;

      if (!individualLocale) return;

      const pickedLocale = 
        individualLocale.ats ||
        individualLocale.workforce ||
        individualLocale.benchsales ||
        null;

      if (pickedLocale) {
        setCurrency(pickedLocale?.currency || "");
        setTimeZone(pickedLocale?.timezone || "");
        setTimeFormat(pickedLocale?.timeFormat || "");
      }
    }
  }, [settingType, role, user]);

  // useEffect(() => {
  //   const fetchOrgLocale = async () => {
  //     try {
  //       setLoading(true);
  //       const res = await getOrganizationLocaleInfo({
  //         coll: "Organization",
  //         fil: {
  //           uiid: { type: "NONE", value: user?.data.organizationId.uiid },
  //         },
  //         ret: "uiid locale",
  //       });

  //       const locale = res?.data?.data?.locale;
  //       if (!locale) return;

  //     if (locale?.default) {
  //       const type = locale.default;

  //       if (type === 1) {
  //         setSettingType(1);
  //       } 
        
  //       else if (type === 2) {
  //         setSettingType(2);
  //         setRole(1);
  //       } 
        
  //       else if (type === 3) {
  //         setSettingType(2);
  //         setRole(2);
  //       }
  //     }

  //       if (locale.default === 1) {
  //         setCurrency(locale.currency || "");
  //         setTimeZone(locale.timezone || "");
  //         setTimeFormat(locale.timeFormat || "");
  //       }
  //     } catch (err) {
  //       console.error("Error fetching org locale:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchOrgLocale();
  // }, []);
  
  const applyLocale = (orgLocale) => {
    const type = orgLocale?.default;

    if (type === 1) {
      setSettingType(1);
    } else if (type === 2) {
      setSettingType(2);
      setRole(1);
    } else if (type === 3) {
      setSettingType(2);
      setRole(2);
    }

    if (type === 1) {
      setCurrency(orgLocale?.currency || "");
      setTimeZone(orgLocale?.timezone || "");
      setTimeFormat(orgLocale?.timeFormat || "");
    }
  };

  useEffect(() => {
    const fetchLocale = async () => {
      try {
        setLoading(true);

        const res = await getOrganizationLocaleInfo({
          coll: "Organization",
          fil: {
            uiid: { type: "NONE", value: user?.data?.organizationId?.uiid },
          },
          ret: "uiid locale",
        });

        const locale = res?.data?.data?.locale;

        if (locale) {
          applyLocale(locale);                   
        }
      } catch (err) {
        console.error("Error fetching org locale:", err);
      } finally {
        setLoading(false);
      }
    };

    const orgLocale = user?.data?.organizationId?.locale;

    if (!orgLocale || Object.keys(orgLocale).length === 0) {
      fetchLocale();
      return;
    }

    applyLocale(orgLocale);
  }, []);

  // useEffect(() => {
  //   const orgLocale = user?.data?.organizationId?.locale;
  //   if (!orgLocale) return;

  //   const type = orgLocale.default;

  //   if (type === 1) {
  //     setSettingType(1);
  //   } else if (type === 2) {

  //     setSettingType(2);
  //     setRole(1);
  //   } else if (type === 3) {
  //     setSettingType(2);
  //     setRole(2);
  //   }

  //   if (type === 1) {
  //     setCurrency(orgLocale?.currency || "");
  //     setTimeZone(orgLocale?.timezone || "");
  //     setTimeFormat(orgLocale?.timeFormat || "");
  //   }
  // }, []);

  return (
    <div className="py-4 px-2">
      <div>
        {/* Setting Type Selection */}
        <FormFieldSet
          type="radio"
          noTitle
          options={[
            { label: "Default Setting", value: 1 },
            { label: "Manual Configuration", value: 2 },
          ]}
          value={settingType}
          onChange={(e) => setSettingType(e.target.value)}
        />

        {/* Module & Role Configuration */}
        {settingType == 2 && (
          <>
            <FormFieldSet
              type="checkbox"
              noTitle
              options={[
                { label: "ATS", value: 1 },
                { label: "Workforce", value: 2 },
                { label: "Benchsales", value: 3 },
              ].filter((option) =>
                isBenchUser ? option.value === 3 : true,
              )}
              values={module}
              onChange={(value) => setModule(value)}
              multiple
            />
            <div className="flex gap-2 items-center my-2">
              <div className="w-[200px]">
                <FormFieldSet
                  type="select"
                  size="sm"
                  title="Select"
                  placeholder="Select"
                  value={role}
                  options={[
                    { label: "Role Based", value: 1 },
                    { label: "Individual Based", value: 2 },
                  ].filter((option) =>
                    isBenchUser ? option.value === 1 : true,
                  )}
                  onChange={(value) => setRole(value)}
                />
              </div>
              {role == 1 && module == 1 && (
                <div className="w-[200px]">
                  <FormFieldSet
                    // type="select"
                    type="atsRoles"
                    size="sm"
                    title="Role Selection"
                    placeholder="select"
                    value={roleSelection}
                    onChange={(value) => {
                      setRoleSelection(value)
                    }}
                  />
                </div>
              )}
              {role == 1 && module == 3 && (
                <div className="w-[200px]">
                  <FormFieldSet
                    // type="select"
                    type="benchsalesRoles"
                    size="sm"
                    title="Role Selection"
                    placeholder="select"
                    value={roleSelection}
                    onChange={(value) => {
                      setRoleSelection(value)
                    }}
                  />
                </div>
              )}
            </div>
          </>
        )}

        {/* Shared Form for SettingType == 1 or Role == 1 or RoleSelection == 1 */}
        {(settingType == 1 || role == 2 || roleSelection) && (
          <div className="grid grid-cols-2 xl:grid-cols-[repeat(3,1fr)_100px] gap-5 my-4">
            {/* Country of Operations (optional) */}
            {/* Uncomment if you want to include country selection */}
            {/* <FormFieldSet
              title="Country Of Operations"
              placeholder="Select"
              type="select"
              value={country}
              onChange={(value) => handleCountryChange(value)}
              options={[
                { label: "USA", value: "USA" },
                { label: "India", value: "India" },
                { label: "UK", value: "UK" },
                { label: "Australia", value: "Australia" },
              ]}
            /> */}

            <FormFieldSet
              title="Time Zone"
              placeholder="Select"
              type="select"
              value={timeZone}
              // onChange={(value) => setTimeZone(value)}
              onChange={handleTimeZoneChange}
              options={[
                { label: "Indian Standard Time", value: 1 },
                { label: "EST (Eastern Standard Time)", value: 2 },
                { label: "PST (Pacific Standard Time)", value: 3 },
              ]}
            />

            {!isBenchUser && <FormFieldSet
              title="Currency"
              placeholder="Select"
              type="select"
              value={currency}
              onChange={(value) => setCurrency(value)}
              options={[
                { label: "USD", value: "USD" },
                { label: "INR", value: "INR" },
                { label: "EUR", value: "EUR" },
                { label: "GBP", value: "GBP" },
              ]}
            />}

            <FormFieldSet
              title="Select Time Format"
              placeholder="Select"
              type="select"
              value={timeFormat}
              onChange={(value) => setTimeFormat(value)}
              options={[
                { label: "12 Hour", value: 1 },
                { label: "24 Hour", value: 2 },
              ]}
            />

            <div className="flex items-end">
              <Button title={"Save"} onClick={handleSave} />
            </div>
          </div>
        )}
      </div>


      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default LocalInformation;
